<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="cancel"
    :visible.sync="dialog"
    :title="isAdd ? (insertFlag ? '插入' : '新增') : '编辑'"
    width="650px"
  >
    <tree ref="tree" @copyOver="copyOver"></tree>
    <!-- 视频弹出 -->
    <el-dialog
      title="任务视频"
      :visible.sync="dialogVisible"
      append-to-body
      width="700px"
    >
      <div
        @click="handleClickVideo(item, index)"
        class="card-box"
        v-for="(item, index) in videoArr"
        :key="index"
      >
        <div class="off-ligh" v-if="item.flag">
          <el-link
            class="text"
            icon="el-icon-circle-plus-outline"
            :underline="false"
            >已选择</el-link
          >
        </div>
        <el-image
          style="width: 210px; height: 128px"
          :src="item.coverUrl"
        ></el-image>
        <span>{{ item.name }}</span>
      </div>
      <span v-if="videoArr.length == 0">没有搜索到结果!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- end -->

    <!-- 音频弹出 -->
    <el-dialog
      title="任务音频"
      :visible.sync="dialogVisible2"
      append-to-body
      width="700px"
    >
      <div
        @click="handleClickAudio(item, index)"
        class="card-box2"
        v-for="(item, index) in audioArr"
        :key="index"
      >
        <div class="off-ligh2" v-if="item.flag">
          <el-link
            class="text"
            icon="el-icon-circle-plus-outline"
            :underline="false"
            >已选择</el-link
          >
        </div>
        <i
          class="music el-icon-headset"
          style="display: inline-block; width: 210px; height: 45px"
        ></i>
        <span>{{ item.name }}</span>
      </div>
      <span v-if="audioArr.length == 0">没有搜索到结果!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible2 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- end -->

    <el-dialog
      title="任务系列"
      :visible.sync="dialogVisible3"
      append-to-body
      width="68%"
    >
      <xilie @selectXilie="selectXilie" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible3 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="题目"
      :visible.sync="dialogVisible4"
      append-to-body
      width="75%"
    >
      <specialTraining ref="specialTraining" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSpecialTraining"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 内容 -->
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      size="small"
      label-width="120px"
    >
      <el-form-item label="任务类型">
        <el-select
          v-model="form.taskType"
          placeholder="请选择"
          style="width: 370px"
          :disabled="!isAdd"
        >
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="别名" v-if="insertFlag === false">
        <el-input v-model="form.alias" style="width: 370px" />
      </el-form-item>
      <el-form-item label="别名" v-if="insertFlag === true" prop="alias">
        <el-input v-model="form.alias" style="width: 370px" />
      </el-form-item>
      <el-form-item
        label="任务名称"
        prop="name"
        :rules="[{ required: true, message: '任务名称不能为空' }]"
      >
        <el-input v-model="form.name" style="width: 370px" />
      </el-form-item>
      <!-- <el-form-item
        label="分类"
        prop="variety"
        :rules="[
      { required: true, message: '分类不能为空'}]"
      >
        <el-select v-model="form.variety" placeholder="请选择" style="width: 370px;">
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="等级"
        prop="difficulty"
        :rules="[
      { required: true, message: '等级不能为空'}]"
      >
        <el-select v-model="form.difficulty" placeholder="请选择" style="width: 370px;">
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="种类"
        prop="classify"
        :rules="[
      { required: true, message: '种类不能为空'}]"
      >
        <el-select v-model="form.classify" placeholder="请选择" style="width: 370px;">
          <el-option
            v-for="item in options3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否题目">
        <el-radio v-model="form.title" label="0">没有</el-radio>
        <el-radio v-model="form.title" label="1">有</el-radio>
      </el-form-item> -->
      <el-form-item label="系列">
        <el-input v-model="form.seriesName" disabled style="width: 296px" />
        <el-button
          type="primary"
          size="mini"
          style="width: 70px"
          @click="handleFind"
          >查找</el-button
        >
      </el-form-item>
      <el-form-item
        label="百度云链接"
        v-if="form.taskType === 0 ? true : false"
      >
        <el-input v-model="form.link" style="width: 370px" />
      </el-form-item>

      <el-form-item label="二维码" v-if="form.taskType === 0 ? true : false">
        <!-- <el-input v-model="form.link" style="width: 370px" /> -->
        <div class="btnPicBox">
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            :auto-upload="false"
            accept=".jpg, .png, .JPG, .PNG, .jpeg, .gif, .JPEG, .GIF "
            :on-change="handlePreview"
            :file-list="fileList"
          >
            <el-button
              icon="el-icon-upload2"
              size="mini"
              class="btnPic"
              style="width: 296px"
              :type="buttonType"
              :disabled="audio"
              :loading="audio"
              >{{ audioText }}</el-button
            >
          </el-upload>
          <el-button
            class="delBtn"
            style="width: 70px"
            type="danger"
            @click="deleTaskqrcode"
            >删除</el-button
          >
        </div>
      </el-form-item>

      <el-form-item label="任务视频" v-if="form.taskType === 0 ? true : false">
        <el-input v-model="videoName" style="width: 296px" />
        <el-button
          @click="searchVideo"
          type="primary"
          size="mini"
          icon="el-icon-search"
          style="width: 70px"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item v-if="videoActive.length !== 0">
        <div
          v-if="item.flag"
          v-for="(item, index) in videoActive"
          :key="item.id"
          class="videoActive"
          style="width: 370px"
        >
          {{ item.name }}
          <el-button
            @click="handleClickRemove(index, item.id)"
            class="btn"
            size="mini"
            icon="el-icon-close"
            circle
          ></el-button>
        </div>
      </el-form-item>
      <el-form-item label="任务音频" v-if="form.taskType === 0 ? true : false">
        <el-input v-model="audioName" style="width: 296px" />
        <el-button
          @click="searchAudio"
          type="primary"
          size="mini"
          icon="el-icon-search"
          style="width: 70px"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item v-if="audioActive.length !== 0">
        <div
          v-if="item.flag"
          v-for="(item, index) in audioActive"
          :key="item.id"
          class="videoActive"
          style="width: 370px"
        >
          {{ item.name }}
          <el-button
            @click="handleClickRemove2(index, item.id)"
            class="btn"
            size="mini"
            icon="el-icon-close"
            circle
          ></el-button>
        </div>
      </el-form-item>
      <!--  -->
      <el-form-item
        label="发音"
        prop="languageType"
        key="languageType"
        :rules="[{ required: true, message: '发音不能为空' }]"
        v-if="form.taskType === 1 ? true : false"
      >
        <el-select
          v-model="form.languageType"
          placeholder="请选择"
          style="width: 370px"
        >
          <el-option
            v-for="item in listArr1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="玩法"
        prop="playMethodIds"
        key="playMethodIds"
        :rules="[{ required: true, message: '玩法不能为空' }]"
        v-if="form.taskType === 1 ? true : false"
      >
        <el-select
          v-model="form.playMethodIds"
          placeholder="请选择"
          style="width: 370px"
        >
          <el-option
            v-for="item in listArr2"
            :key="item.id"
            :label="item.playMethodName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!--  -->
      <el-form-item
        label="词库list"
        prop="playTaskList"
        key="playTaskList"
        :rules="[{ required: true, message: '词库list不能为空' }]"
        v-if="form.taskType === 1 ? true : false"
      >
        <el-button
          style="width: 370px"
          size="mini"
          type="primary"
          @click="addList"
          >点击添加</el-button
        >
      </el-form-item>
      <!--  -->
      <el-form-item
        v-if="form.taskType === 1 ? true : false"
        label=" "
        v-for="(item, index) of form.playTaskList"
        :key="index"
      >
        <el-tag style="width: 370px">{{ item.listName || item.name }}</el-tag>
        <el-button
          @click="remove(index)"
          type="danger"
          plain
          size="mini"
          style="margin-left: 10px"
          icon="el-icon-delete"
          circle
        />
      </el-form-item>
      <!--  -->
      <!-- 专项训练 -->
      <el-form-item
        label="专项训练列表"
        prop="tableId"
        key="tableId"
        :rules="[{ required: true, message: '专项训练列表不能为空' }]"
        v-if="form.taskType === 2 ? true : false"
      >
        <el-select
          v-model="form.tableId"
          placeholder="请选择"
          style="width: 370px"
        >
          <el-option
            v-for="item in TableFullTypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题目" v-if="form.taskType === 2 ? true : false">
        <el-button
          :disabled="!form.tableId"
          @click="showQuestion"
          size="mini"
          style="width: 370px"
          type="primary"
          v-loading.fullscreen.lock="fullscreenLoading"
        >
          点击选择题目</el-button
        >
      </el-form-item>
      <el-form-item
        label="种类"
        prop="speciesId"
        key="speciesId"
        :rules="[{ required: true, message: '种类不能为空' }]"
        v-if="form.taskType === 2 ? true : false"
      >
        <el-select
          v-model="form.speciesId"
          placeholder="请选择"
          style="width: 370px"
        >
          <el-option
            v-for="item in typeArr"
            :key="item.id"
            :label="item.speciesName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="科目"
        prop="subjectId"
        key="subjectId"
        :rules="[{ required: true, message: '科目不能为空' }]"
        v-if="form.taskType === 2 ? true : false"
      >
        <el-select
          v-model="form.subjectId"
          placeholder="请选择"
          style="width: 370px"
        >
          <el-option
            v-for="item in newSubArr"
            :key="item.subjectId"
            :label="item.subjectName"
            :value="item.subjectId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 专项训练end -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="cancel">取消</el-button>
      <el-button :loading="loading" type="primary" @click="doSubmit"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { add, edit, getVedio, getAudio, postInsertTask } from "@/api/task";
import { getPlayMethod } from "@/api/playMethod";
import specialTraining from "@/views/train/specialTraining/index";
import qs from "qs";
import xilie from "./xilie";
import tree from "./tree";
import { getSubjectFull } from "@/api/teacher";
import { getTableFullType } from "@/api/table"; //获得专项训练列表
import OSS from "ali-oss";
import { getUUID } from "@/utils/uuid";
export default {
  components: {
    xilie,
    tree,
    specialTraining,
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
    typeArr: Array,
  },
  data() {
    return {
      fileList: [],
      audioText: "点击上传",
      audio: false,
      buttonType: "primary",
      // 新加专项训练
      // typeArr: null,
      newSubArr: [], //全部科目
      TableFullTypeArr: [], //专项训练列表

      fullscreenLoading: false,
      // 新加专项训练end
      // 新增
      listArr2: [],
      listArr1: [
        {
          value: 2,
          label: "英式",
        },
        {
          value: 3,
          label: "美式",
        },
      ],
      options: [],
      typeList: [
        {
          id: 0,
          value: "常规任务",
        },
        {
          id: 1,
          value: "词库list任务",
        },
        {
          id: 2,
          value: "专项训练",
        },
      ],
      // 新增end
      insertFlag: false,
      loading: false,
      dialog: false,
      //   视频搜索
      dialogVisible: false,
      videoName: "",
      videoArr: [],
      videoActive: [],

      //   音频搜索
      dialogVisible2: false,
      audioName: "",
      audioArr: [],
      audioActive: [],

      //系列
      dialogVisible3: false,
      selectArr: {},
      dialogVisible4: false,
      //   ---------
      form: {
        taskqrcode: null, //二维码
        taskType: 0,
        alias: "",
        name: "",
        variety: "", //大分类
        classify: "", //小分类
        difficulty: "", //等级
        link: "",
        series: "", //系列
        title: "0", // 0无 // 1有
        seriesName: "",
        idArray: [],
        playTaskList: [],
        playMethodIds: null,
        languageType: null,
        // 测试训练
        speciesId: null,
        tableId: null,
        specialTrainingQuestion: null,
        subjectId: null,
      },
      rules: {},
      // options1: [
      //   {
      //     value: 1,
      //     label: "雅思",
      //   },
      //   {
      //     value: 2,
      //     label: "托福",
      //   },
      //   {
      //     value: 3,
      //     label: "公用",
      //   },
      // ],
      options2: [
        {
          value: 1,
          label: "基础",
        },
        {
          value: 2,
          label: "高级",
        },
      ],
      options3: [
        {
          value: 1,
          label: "听力",
        },
        {
          value: 2,
          label: "口语",
        },
        {
          value: 3,
          label: "阅读",
        },
        {
          value: 4,
          label: "写作",
        },
      ],
    };
  },
  created() {
    this.getSubTableTypeFn();
  },
  methods: {
    deleTaskqrcode() {
      this.form.taskqrcode = null;
    },
    async ossAudioPut(file, name) {
      let client = new OSS({
        region: "oss-cn-qingdao",
        accessKeyId: "LTAI4FnwTeoAmdGYHhJhZVTb",
        accessKeySecret: "pllurUCqkw5O4XxETNXnQg12mC5vQS",
        bucket: "jingjingliuxue",
      });
      this.audio = true;
      this.audioText = "正在拼命加载";
      try {
        await client.put(`taskQrCode/${getUUID()}${name}`, file).then((e) => {
          // this.putDataFn(e.url);
          this.form.taskqrcode = e.url;
          this.audio = false;
          this.$message({
            message: "图片加载完毕",
            type: "success",
          });
          this.audioText = "已加载完毕, (点击重新选择)";
          this.buttonType = "success";
        });
      } catch (e) {
        this.audio = false;
        this.$message({
          message: "图片加载失败",
          type: "warning",
        });
      }
    },
    closeSpecialTraining() {
      this.selectArr = this.$refs.specialTraining.selectArr;
      this.dialogVisible4 = false;
    },
    showQuestion() {
      //选择专项训练的题目
      // this.questionBankManage.selectFlag = true;
      this.fullscreenLoading = true;
      this.dialogVisible4 = true;

      setTimeout(() => {
        this.$refs.specialTraining.selectFlag = true;
        this.$refs.specialTraining.selectArr = this.selectArr
        this.$refs.specialTraining.tableChange(+this.form.tableId);
        // this.$refs.specialTraining.search();
        this.fullscreenLoading = false;
      }, 1000);
    },
    showPut() {},
    handlePreview(e) {
      this.fileList = [];
      this.fileList.push({ name: e.name });
      this.ossAudioPut(e.raw, e.size);
    },
    // 获得全部科目和专项训练列表
    getSubTableTypeFn() {
      Promise.all([getTableFullType(), getSubjectFull()]).then((val) => {
        console.log(val);
        console.log("val");
        this.TableFullTypeArr = val[0];
        this.newSubArr = val[1];
      });
    },
    // 新增
    remove(e) {
      this.form.playTaskList.splice(e, 1);
    },
    addList() {
      let _this = this.$refs.tree;
      _this.dialog = true;
      let _obj = JSON.stringify(this.form.playTaskList);
      _this.selectId = JSON.parse(_obj);
    },
    copyOver(e) {
      console.log(e);
      this.form.playTaskList = e;
    },
    // 新增end
    handleFind() {
      console.log(this.form.title);

      this.dialogVisible3 = true;
    },
    selectXilie(e) {
      this.form.seriesName = e.name;
      this.form.series = e.id;
      this.dialogVisible3 = false;
    },
    handleClickEdit(e) {
      console.log(e);
      this.form.idArray = [];
      for (let i in e) {
        this.form.idArray.push(e[i].id);
        if (e[i].fileType === "视频") {
          let a = e[i];
          a.flag = true;
          this.videoActive.push(a);
        } else {
          let a = e[i];
          a.flag = true;
          this.audioActive.push(a);
        }
      }
      console.log(this.form.idArray);
    },
    //-----音频-------
    searchAudio() {
      if (this.audioName === "") {
        this.$message({
          message: "请输入视频关键字",
          type: "warning",
        });
        return;
      }
      this.dialogVisible2 = true;
      getAudio(
        qs.stringify({
          name: this.audioName,
        })
      ).then((e) => {
        this.audioArr = [];
        this.audioArr = e.content;
        for (let i in this.audioArr) {
          for (let j in this.form.idArray) {
            if (this.form.idArray[j] === this.audioArr[i].id) {
              this.audioArr[i].flag = true;
            }
          }
        }
      });
    },
    //选中音频
    handleClickAudio(e, r) {
      console.log(e);
      for (let i in this.audioActive) {
        if (this.audioActive[i].id === e.id) {
          this.audioActive.splice(i, 1);
        }
      }
      for (let i in this.form.idArray) {
        if (this.form.idArray[i] === e.id) {
          this.form.idArray.splice(i, 1);
          this.audioArr[r].flag = false;
          this.audioArr.push(0);
          this.audioArr.splice(this.audioArr.length - 1, 1);
          return;
        }
      }
      this.audioActive.push(e);
      this.form.idArray.push(e.id);
      this.audioArr[r].flag = true;
      this.audioArr.push(0);
      this.audioArr.splice(this.audioArr.length - 1, 1);
    },

    //删除已选中音频
    handleClickRemove2(e, r) {
      this.audioActive.splice(e, 1);
      for (let i in this.form.idArray) {
        if (this.form.idArray[i] === r) {
          this.form.idArray.splice(i, 1);
        }
      }
    },

    // ------视频---------
    //删除已选中视频
    handleClickRemove(e, r) {
      this.videoActive.splice(e, 1);
      for (let i in this.form.idArray) {
        if (this.form.idArray[i] === r) {
          this.form.idArray.splice(i, 1);
        }
      }
    },
    //选中视频
    handleClickVideo(e, r) {
      for (let i in this.videoActive) {
        if (this.videoActive[i].id === e.id) {
          this.videoActive.splice(i, 1);
        }
      }
      for (let i in this.form.idArray) {
        if (this.form.idArray[i] === e.id) {
          this.form.idArray.splice(i, 1);
          this.videoArr[r].flag = false;
          this.videoArr.push(0);
          this.videoArr.splice(this.videoArr.length - 1, 1);
          return;
        }
      }
      this.videoActive.push(e);
      this.form.idArray.push(e.id);
      this.videoArr[r].flag = true;
      this.videoArr.push(0);
      this.videoArr.splice(this.videoArr.length - 1, 1);
    },
    //搜索视频
    searchVideo() {
      console.log("123213");
      console.log(this.form);
      if (this.videoName === "") {
        this.$message({
          message: "请输入视频关键字",
          type: "warning",
        });
        return;
      }
      this.dialogVisible = true;
      getVedio(
        qs.stringify({
          name: this.videoName,
        })
      ).then((e) => {
        this.videoArr = [];
        this.videoArr = e.content;
        console.log(this.videoArr);
        console.log("分开");
        console.log(this.form.idArray);
        for (let i in this.videoArr) {
          for (let j in this.form.idArray) {
            if (this.form.idArray[j] === this.videoArr[i].id) {
              this.videoArr[i].flag = true;
            }
          }
        }
      });
    },
    cancel() {
      this.resetForm();
    },
    doSubmit() {
      console.log(this.form);
      console.log("this.form");
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.specialTrainingQuestion = [];
          for (let i in this.selectArr) {
            this.form.specialTrainingQuestion.push(i);
          }
          if (this.isAdd) {
            this.doAdd();
          } else this.doEdit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    doAdd() {
      if (this.insertFlag === true) {
        //插入
        postInsertTask(this.form)
          .then((res) => {
            this.resetForm();
            this.$notify({
              title: "插入成功",
              type: "success",
              duration: 2500,
            });
            this.loading = false;
            this.$parent.init();
          })
          .catch((err) => {
            this.loading = false;
            console.log(err.response.data.message);
          });
      } else {
        //新增
        console.log(this.form);
        // return;
        add(this.form)
          .then((res) => {
            this.$notify({
              title: "添加成功",
              type: "success",
              duration: 2500,
            });
            console.log("resetForm");
            this.resetForm();
            this.loading = false;
            this.$parent.init();
          })
          .catch((err) => {
            this.loading = false;
            console.log(err.response.data.message);
          });
      }
    },
    //
    doEdit() {
      console.log("进入");
      edit(this.form)
        .then((res) => {
          this.resetForm();
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500,
          });
          this.loading = false;
          this.$parent.init();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err.response.data.message);
        });
    },
    resetForm() {
      (this.fileList = []),
        (this.audioText = "点击上传"),
        (this.audio = false),
        (this.buttonType = "primary"),
        (this.dialog = false);
      this.$refs["form"].resetFields();
      this.videoName = "";
      this.videoArr = [];
      this.videoActive = [];
      this.audioName = "";
      this.audioArr = [];
      this.audioActive = [];
      this.form = {
        taskType: 0,
        alias: "",
        name: "",
        variety: "", //大分类
        classify: "", //小分类
        difficulty: "", //等级
        series: "", //系列
        title: "0", // 0无 // 1有
        link: "",
        seriesName: "",
        idArray: [],
        playTaskList: [],
        playMethodIds: null,
        languageType: null,
        // 测试训练
        speciesId: null,
        tableId: null,
        subjectId: null,
      };
    },
    getPlayMethodFn() {
      //获取玩法
      getPlayMethod().then((e) => {
        console.log("1231231231231234324u23iu4hieruwhiu");
        console.log(e);
        this.listArr2 = e.content;
      });
    },
  },
  beforeMount() {
    this.getPlayMethodFn();
  },
};
</script>

<style scoped>
.card-box {
  display: inline-block;
  margin: 5px;
  width: 210px;
  height: 158px;
  border-radius: 8px;
  box-shadow: 0px 0px 5px #ccc;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  user-select: none;
}
.card-box2 {
  display: inline-block;
  margin: 5px;
  width: 210px;
  height: 70px;
  border-radius: 8px;
  box-shadow: 0px 0px 5px #ccc;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  user-select: none;
}
.card-box span {
  display: inline-block;
  width: 100%;
  text-align: center;
  line-height: 22px;
}
.card-box2 span {
  display: inline-block;
  width: 100%;
  text-align: center;
  line-height: 22px;
}
.off-ligh {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  text-align: center;
  line-height: 140px;
  animation: down_in 0.3s;
}
.off-ligh2 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  text-align: center;
  line-height: 70px;
  animation: down_in 0.3s;
}
@keyframes down_in {
  from {
    opacity: 0;
    top: -20px;
  }
  to {
    opacity: 1;
    top: 0;
  }
}
.text {
  font-weight: 700;
  font-size: 18px;
  color: rgb(12, 243, 24);
}
.text:hover {
  color: rgb(12, 243, 24);
}
.videoActive {
  /* border-bottom: 1px solid #eee; */
  user-select: none;
  position: relative;
}
.videoActive:hover {
  color: rgb(0, 133, 250);
  text-shadow: 2px 2px 2px #ccc;
}
.videoActive .btn {
  position: absolute;
  top: 2px;
  right: 10px;
  transform: scale(0.6);
  font-size: 20px;
  font-weight: 700;
  border: none;
  background-color: #f6f6ff;
}
.videoActive .btn:hover {
  color: rgb(0, 133, 250);
  text-shadow: 2px 2px 2px #ccc;
  background-color: #f1f1ff;
}
.music {
  font-size: 30px;
  color: aqua;
  font-weight: 700;
  text-align: center;
  line-height: 45px;
  background-color: #f6f6f6;
}
.btnPicBox {
  display: flex;
}
.delBtn {
  display: inline-block !important;
  margin-left: 4px;
  margin-top: 2px;
  height: 29px;
  line-height: 29rpx;
}
</style>
